import { render, staticRenderFns } from "./SidebarZones.vue?vue&type=template&id=f4b72a64&scoped=true&"
import script from "./SidebarZones.vue?vue&type=script&lang=ts&"
export * from "./SidebarZones.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarZones.vue?vue&type=style&index=0&id=f4b72a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b72a64",
  null
  
)

export default component.exports